import getConfig from 'next/config'
import Head from 'next/head'

export const KikinHead = () => {
    const { publicRuntimeConfig } = getConfig()
    const isDev = publicRuntimeConfig.environment !== 'production'
    const faviconPrefix = isDev ? 'favicon-dev' : 'favicon'

    return (
        <Head>
            <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
            <link rel="icon" type="image/png" sizes="32x32" href={`/${faviconPrefix}-32x32.png`} />
            <link rel="icon" type="image/png" sizes="16x16" href={`/${faviconPrefix}-16x16.png`} />
            <link rel="icon" type="image/x-icon" href={`/${faviconPrefix}.ico`} />
            <link rel="manifest" href="/site.webmanifest" />
            <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
            <meta name="msapplication-TileColor" content={isDev ? '#CC0000' : '#6ad762'} />
            <meta name="theme-color" content={isDev ? '#CC0000' : '#ffffff'} />
        </Head>
    )
}
